function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256,242.4c-63.8,0-115.7-51.9-115.7-115.7 0-63.8 51.9-115.7 115.7-115.7 63.8,0 115.7,51.9 115.7,115.7 0,63.8-51.9,115.7-115.7,115.7zm0-190.6c-41.3,1.42109e-14-74.9,33.6-74.9,74.9 0,41.3 33.6,74.9 74.9,74.9 41.3,0 74.9-33.6 74.9-74.9 0-41.3-33.6-74.9-74.9-74.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m480.6,501h-449.2c-11.3,0-20.4-9.1-20.4-20.4 0-66.7 26-129.2 73.1-176 30.4-30.2 73.3-47.5 117.6-47.5h108.6c44.4,0 87.2,17.3 117.6,47.5 47.1,46.8 73.1,109.3 73.1,176 0,11.3-9.1,20.4-20.4,20.4zm-427.8-40.8h406.4c-4.6-48-25.6-92.4-60.1-126.6-22.8-22.6-55.2-35.6-88.8-35.6h-108.6c-33.7,0-66,13-88.8,35.6-34.5,34.2-55.5,78.6-60.1,126.6z"
}))));

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.149af9f4.svg";
export { ForwardRef as ReactComponent };